import { render, staticRenderFns } from "./wordsRoll.vue?vue&type=template&id=18bd294a&scoped=true"
import script from "./wordsRoll.vue?vue&type=script&lang=js"
export * from "./wordsRoll.vue?vue&type=script&lang=js"
import style0 from "./wordsRoll.vue?vue&type=style&index=0&id=18bd294a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18bd294a",
  null
  
)

export default component.exports